<template>
  <div class="modal_user">
    <div class="modal_user__header">
      <h4 class="title">
        {{ primary_data.id? primary_data.name : translate('user.add') }}
      </h4>
    </div>
    <div class="modal_user__body">
      <div class="user">
        <div class="tab">
          <span
              class="tab_title"
              :class="{ active : block==='MainInfo'}"
              @click="selected_block('MainInfo')"
          >
              {{translate('user.main_info.title')}}
          </span>
        </div>
        <div class="block">
          <MainInfo
              v-if="block==='MainInfo'"
              :main_info="main_info"
              :client_ids="client_ids"
              @close="$emit('close')"
          />
        </div>
      </div>


    </div>
    <div class="modal_user__footer">
      <div class="text-center">
        <button
          type="submit"
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="close"
        >
          {{ translate('close_modal') }}
        </button>
      </div>
    </div>

  </div>
</template>
<script>

import MainInfo from "./Tabs/MainInfo.vue";

export default {
  name: 'EditUserProfile',
  props: ['user', 'client_ids'],
  components: {
    MainInfo
  },
  data () {
    return {
      block: 'MainInfo',
      disabled_btn: false,
      primary_data: {
        name: ''
      },
    }
  },
  created() {
    this.primary_data = Object.assign({}, this.user)
  },

  computed:{
    main_info(){
      let user_info = Object.assign({}, this.primary_data)
      delete(user_info.roles)
      delete(user_info.device_groups)
      return user_info
    },
  },

  methods: {
    close () {
      this.$emit('close')
    },
    selected_block(block){
      this.block = block
    },
  }
}

</script>

<style lang='scss' scoped>
  .modal_user{
    height: 100%;
    padding: 10px;
    &__header{
      height: 5%;
      .title{
        margin: 0 0 10px 0;
        text-align: center;
      }
    }
    &__body{
      width: 100%;
      height: 90%;
      .loading{
        border:none;
        background-color: transparent;
      }
      .user{
        width: 100%;
        height: 100%;
        .tab{
          width: 100%;
          height: 5%;
          display: flex;
          align-content: center;
          justify-content: center;
          flex-direction: row;
          &_title{
            width: 100%;
            padding: 5px 0;
            cursor: pointer;
            font-weight: 600;
            text-align: center;
            background-color: #efe9e9;
            border: 1px solid #efe9e9;
            &.active{
              background-color: #FFFFFF;
              border-bottom: 1px solid white;
            }
          }
        }
        .block{
          height: 95%;
          border: 1px solid #efe9e9;
          margin-top: -1px;
          padding: 10px;
        }
      }

    }
    &__footer{
      height: 5%;
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }


</style>
